import React, { useState } from "react";
import { Pencil, ChevronDown, Plus } from 'lucide-react';
import Sidebar1 from "components/Sidebar1";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const INITIAL_DATA = [
    { id: 1, name: "SUPER 98", nameAr: "ممتاز", price: "3.34", month: "July", year: "2024", color: "#0897D3" },
    { id: 2, name: "Special 95", nameAr: "خصوصي ٩٥", price: "3.22", month: "July", year: "2024", color: "#12A54B" },
    { id: 3, name: "E Plus 91", nameAr: "إي بلس ٩١", price: "3.15", month: "July", year: "2024", color: "#EAB72B" },
    { id: 4, name: "Diesel", nameAr: "ديزل", price: "3.40", month: "July", year: "2024", color: "#2D2D2D" },
];

const EMPTY_FORM = { id: null, name: "", nameAr: "", price: "", month: "July", year: "2024", color: "#000000" };

export default function AdminFuelPricesPage() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [fuelList, setFuelList] = useState(INITIAL_DATA);
    const [selectedItem, setSelectedItem] = useState(INITIAL_DATA[0]);
    const [isAddingNew, setIsAddingNew] = useState(false);

    // Form inputs change handler
    const handleChange = (e) => {
        const { name, value } = e.target;
        setSelectedItem(prev => ({ ...prev, [name]: value }));
    };

    // Add New Button logic
    const handleAddNewClick = () => {
        setIsAddingNew(true);
        setSelectedItem({ ...EMPTY_FORM, id: Date.now() }); // Unique temporary ID
    };

    // Save or Update logic
    const handleSave = () => {
        if (!selectedItem.name || !selectedItem.price) {
            toast.error("Please fill required fields (Name & Price)");
            return;
        }

        if (isAddingNew) {
            setFuelList([...fuelList, selectedItem]);
            setIsAddingNew(false);
            toast.success("Fuel type added successfully!");
        } else {
            setFuelList(prev => prev.map(item => item.id === selectedItem.id ? selectedItem : item));
            toast.success("Fuel details updated!");
        }
    };

    // Delete logic with fix
    const handleDelete = () => {
        const idToDelete = selectedItem.id;
        const updatedList = fuelList.filter(item => item.id !== idToDelete);
        
        setFuelList(updatedList);
        toast.info("Fuel type removed");

        // UI Fix: Agar list khali nahi hai toh pehla item select karo, warna Add New mode open karo
        if (updatedList.length > 0) {
            setSelectedItem(updatedList[0]);
            setIsAddingNew(false);
        } else {
            handleAddNewClick();
        }
    };

    return (
        <div className="flex h-screen bg-[#F8F9FA] overflow-hidden font-sans">
            <Sidebar1 isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
            
            {/* Toast Container for notifications */}
            <ToastContainer position="top-right" autoClose={3000} theme="colored" />

            <main className="flex-1 flex flex-col min-w-0 overflow-hidden">
                {/* Header */}
                <header className="flex items-center justify-between p-6 lg:px-10">
                    <h1 style={{fontFamily:'NeueMontreal'}} className="text-2xl font-semibold text-gray-900" >
                        Current Fuel Prices
                    </h1>
                    <div className="w-10 h-10 rounded-full overflow-hidden border">
                        <img src="https://i.pravatar.cc/150?u=admin" alt="Admin" className="w-full h-full object-cover" />
                    </div>
                </header>

                <div className="flex-1 flex gap-8 px-6 lg:px-10 pb-10 overflow-hidden">
                    
                    {/* LEFT: List Section */}
                    <div className="w-1/3 flex flex-col gap-4">
                        <button  style={{color:'white',fontFamily:'NeueMontreal',backgroundColor:'#EA352B',padding:'16px',borderRadius:'24px',fontWeight:'medium',fontSize:'14px',boxShadow:'0px 4px 6px rgba(234, 53, 43, 0.2)',transition:'background-color 0.3s ease'}}
                            onClick={handleAddNewClick}
                            className="flex items-center justify-center gap-2 bg-black text-white py-3 rounded-xl text-sm font-medium hover:bg-gray-800 transition shadow-sm"
                        >
                            <Plus size={18} /> Add New Fuel
                        </button>

                        <div style={{background:'white',boxShadow:'0px 0px 3px 0px #c3c3c3d1'}} className="bg-white rounded-[24px] border border-gray-100 shadow-sm overflow-hidden flex-1 overflow-y-auto">
                            {fuelList.map((item) => (
                                <div 
                                    key={item.id}
                                    onClick={() => { setSelectedItem(item); setIsAddingNew(false); }}
                                    className={`flex items-center justify-between p-5 border-b border-gray-50 cursor-pointer transition-colors ${selectedItem?.id === item.id && !isAddingNew ? 'bg-gray-50 border-l-4 border-red-500' : 'hover:bg-gray-50/50'}`}
                                >
                                    <span className="font-medium text-gray-800 uppercase tracking-wide text-sm">{item.name}</span>
                                    <Pencil size={14} className="text-gray-400" />
                                </div>
                            ))}
                            {fuelList.length === 0 && (
                                <div className="p-10 text-center text-gray-400 text-sm">No fuels added yet.</div>
                            )}
                        </div>
                    </div>

                    {/* RIGHT: Form Section */}
                    <div style={{background:'white',boxShadow:'0px 0px 3px 0px #c3c3c3d1',fontFamily:'NeueMontreal'}} className="flex-1 bg-white rounded-[32px] border border-gray-100 shadow-sm p-8 overflow-y-auto relative">
                        <div className="flex justify-between items-center mb-8">
                            <h2 style={{fontFamily:'NeueMontreal',color:'black'}} className="text-lg font-bold">
                                {isAddingNew ? "Create New Fuel Type" : "Modify Details"}
                            </h2>
                            {!isAddingNew && fuelList.length > 0 && (
                                <button 
                                    onClick={handleDelete}
                                    className="bg-[#EA352B]/10 text-[#EA352B] hover:bg-[#EA352B] hover:text-white px-5 py-2 rounded-lg text-xs font-bold transition-all"
                                >
                                    Delete
                                </button>
                            )}
                        </div>

                        <div className="space-y-6">
                            {/* Title (English) */}
                            <div>
                                <label className="block text-black text-md mb-2 font-light ">Title (English)</label>
                                <input  style={{fontFamily:'NeueMontreal',backgroundColor:'#F6F6F6',borderColor:'transparent',borderRadius:'16px',padding:'16px',fontSize:'14px',transition:'border-color 0.3s ease'}}
                                    type="text"
                                    name="name"
                                    value={selectedItem?.name || ""}
                                    onChange={handleChange}
                                    className="w-full bg-[#F6F6F6] border border-transparent rounded-xl p-4 text-sm focus:border-gray-200 outline-none transition"
                                />
                            </div>

                            {/* Title (Arabic) */}
                            <div className="text-right">
                                <label className="block text-black text-md mb-2 font-light ">عنوان (العربية)</label>
                                <input  style={{fontFamily:'NeueMontreal',backgroundColor:'#F6F6F6',borderColor:'transparent',borderRadius:'16px',padding:'16px',fontSize:'14px',transition:'border-color 0.3s ease'}}
                                    type="text"
                                    name="nameAr"
                                    dir="rtl"
                                    value={selectedItem?.nameAr || ""}
                                    onChange={handleChange}
                                    className="w-full bg-[#F6F6F6] border border-transparent rounded-xl p-4 text-sm text-right focus:border-gray-200 outline-none transition"
                                />
                            </div>

                            {/* Price */}
                            <div>
                                <label className="block text-black text-md mb-2 font-light ">Price</label>
                                <div className="relative">
                                    <input  style={{fontFamily:'NeueMontreal',backgroundColor:'#F6F6F6',borderColor:'transparent',borderRadius:'16px',padding:'16px',fontSize:'14px',transition:'border-color 0.3s ease'}}
                                        type="number"
                                        name="price"
                                        value={selectedItem?.price || ""}
                                        onChange={handleChange}
                                        className="w-full bg-[#FBFBFB] border border-transparent rounded-xl p-4 text-sm focus:border-gray-200 outline-none transition"
                                    />
                                    <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 text-xs font-bold">AED</span>
                                </div>
                            </div>

                            {/* Month & Year Selection */}
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-black text-md mb-2 font-light ">Month</label>
                                    <div className="relative">
                                        <select  style={{fontFamily:'NeueMontreal',backgroundColor:'#F6F6F6',borderColor:'transparent',borderRadius:'16px',padding:'16px',fontSize:'14px',transition:'border-color 0.3s ease'}}
                                            name="month"
                                            value={selectedItem?.month || "July"}
                                            onChange={handleChange}
                                            className="w-full bg-[#FBFBFB] border border-transparent rounded-xl p-4 text-sm appearance-none outline-none focus:border-gray-200"
                                        >
                                            <option>July</option>
                                            <option>August</option>
                                            <option>September</option>
                                        </select>
                                        <ChevronDown className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
                                    </div>
                                </div>
                                <div>
                                    <label className="block text-black text-md mb-2 font-light ">Year</label>
                                    <div className="relative">
                                        <select  style={{fontFamily:'NeueMontreal',backgroundColor:'#F6F6F6',borderColor:'transparent',borderRadius:'16px',padding:'16px',fontSize:'14px',transition:'border-color 0.3s ease'}}
                                            name="year"
                                            value={selectedItem?.year || "2024"}
                                            onChange={handleChange}
                                            className="w-full bg-[#FBFBFB] border border-transparent rounded-xl p-4 text-sm appearance-none outline-none focus:border-gray-200"
                                        >
                                            <option>2024</option>
                                            <option>2025</option>
                                        </select>
                                        <ChevronDown className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
                                    </div>
                                </div>
                            </div>

                            {/* Color Selector */}
                            <div>
                                <label className="block text-black text-md mb-2 font-light ">Color Code</label>
                                <div className="relative">
                                    <input  style={{fontFamily:'NeueMontreal',backgroundColor:'#F6F6F6',borderColor:'transparent',borderRadius:'16px',padding:'16px',fontSize:'14px',transition:'border-color 0.3s ease'}}
                                        type="text"
                                        name="color"
                                        value={selectedItem?.color || ""}
                                        onChange={handleChange}
                                        className="w-full bg-[#FBFBFB] border border-transparent rounded-xl p-4 text-sm focus:border-gray-200 outline-none uppercase"
                                    />
                                    <div 
                                        className="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full border-2 border-white shadow-md"
                                        style={{ backgroundColor: selectedItem?.color }}
                                    ></div>
                                </div>
                            </div>

                            {/* Save Button */}
                            <button  style={{color:'white',fontFamily:'NeueMontreal',backgroundColor:'#EA352B',padding:'16px',borderRadius:'24px',fontWeight:'medium',fontSize:'14px',boxShadow:'0px 4px 6px rgba(234, 53, 43, 0.2)',transition:'background-color 0.3s ease'}}
                                onClick={handleSave}
                                className="w-full bg-[#EA352B] text-white py-4 rounded-2xl text-sm mt-4 hover:bg-red-600 transition shadow-lg shadow-red-100 active:scale-95"
                            >
                                {isAddingNew ? "Add Fuel Type" : "Save Changes"}
                            </button>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}